if($('.form-options-question').length) {

    let formSelect = $('#contact_form_options'),
        formOptions = $('.contact-form-options .form-option');

    setTimeout(() => {
        $('.form-option-1').addClass('d-none');
    }, 2000);

    formSelect.on('change', function() {

        console.log($(this).val());
        formOptions.addClass('d-none');
        $('.contact-form-options .form-option-' + $(this).val()).removeClass('d-none');

    });

}
